import { useSelector } from "react-redux";

import { Modal } from "@/components/General/Modal/modal";
import { WishListActionable } from "@/components/Wishlist/WishlistActionable/WishListActionable.component";
import { APIStatus } from "@/redux/modules/api/data/wishlist/wishlist.module";
import {
    getWishlists,
    isLoading
} from "@/redux/modules/api/data/wishlist/wishlist.selectors";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { TApiAction } from "@/redux/store.types";

import { WishlistActionableMode } from "../../WishlistActionable/WishListActionable.types";

type WishlistItemMoveModalContainerProps = {
    open: boolean;
    currentWishlistId: string;
    onMove: (
        targetListId?: string,
        newListName?: string
    ) => Promise<TApiAction | undefined>;
    onClose: () => void;
};

const FORM_ID = "wishlist-move";

export const WishlistItemMoveModalContainer = ({
    open,
    currentWishlistId,
    onMove,
    onClose
}: WishlistItemMoveModalContainerProps) => {
    const { t } = useGranite();
    const wishlists = useSelector(getWishlists);
    const wishlistsLoading = useSelector(isLoading);

    const submit = ({
        wishlistId,
        wishlistName
    }: {
        wishlistId?: string;
        wishlistName?: string;
    }) => {
        onMove(wishlistId, wishlistName).then((action) => {
            if (action?.type === APIStatus.SUCCESS) {
                onClose();
            }
        });
    };

    return (
        <Modal
            modalType={ModalType.WishlistMove}
            title={t("wishlist.move.modal.title")}
            open={open}
            autoFocus={true}
            formId={FORM_ID}
            centered={true}
            withFooter={true}
            setOpen={onClose}
            confirmButtonText={t("wishlist.move.form.submit")}
        >
            <div className="mb-3">
                <WishListActionable
                    loading={wishlistsLoading}
                    wishlists={wishlists}
                    submit={submit}
                    mode={WishlistActionableMode.MOVE}
                    currentWishlistId={currentWishlistId}
                    formId={FORM_ID}
                />
            </div>
        </Modal>
    );
};
